import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

import Config from '@/config';
import Chat from './chat';
import Channel from './channel';
import Concierge from './concierge';
import User from './user';
import Trip from './trip';
import Layout from './layout';

Vue.use(Vuex);
const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  modules: ['Concierge']
});

// Reusable, one instance of vuex only
// Only use for global
export default new Vuex.Store({
  strict: Config.ENV !== 'production',
  mutations: {
    // update state
  },
  actions: {
    // call mutation. async
  },
  getters: {
    // TODO: get state
  },
  modules: {
    Chat,
    Channel,
    Concierge,
    User,
    Trip,
    Layout
  },
  plugins: [vuexLocal.plugin]
});
